import { useEffect, useState } from 'react';
import { Link, useParams, useSearchParams } from 'react-router-dom';
import axios from 'axios';
import './ViewMessage.css';

const ViewMessage = () => {
  const { id } = useParams();
  const [searchParams] = useSearchParams();
  const requestedAdminView = searchParams.get('adminView') === '1';
  const [message, setMessage] = useState(null);
  const [error, setError] = useState('');
  const [visible, setVisible] = useState(false);
  axios.defaults.withCredentials = true;
  const token = sessionStorage.getItem('jwtToken');

  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_BACKEND_URL}/messages/getmessage/${id}`, {
        params: requestedAdminView ? { admin_view: '1' } : undefined,
        headers: { Authorization: `Bearer ${token}` },
      })
      .then(async (res) => {
        setMessage(res.data);
        setTimeout(() => setVisible(true), 30);

        if (!res.data.admin_view && res.data.receiver_id && !res.data.is_read) {
          await axios.put(
            `${process.env.REACT_APP_BACKEND_URL}/messages/read/${id}`,
            {},
            { headers: { Authorization: `Bearer ${token}` } }
          );
        }
      })
      .catch(() => setError('Bericht niet gevonden'));
  }, [id, token, requestedAdminView]);

  if (error) return (
    <div className="vm-container">
      <div className="vm-error">
        <i className="bi bi-exclamation-circle me-2"></i>{error}
      </div>
    </div>
  );

  if (!message) return (
    <div className="vm-container">
      <div className="vm-loading">
        <div className="vm-loading-dot"></div>
        <div className="vm-loading-dot"></div>
        <div className="vm-loading-dot"></div>
      </div>
    </div>
  );

  const formattedDate = new Date(message.created_at).toLocaleDateString('nl-NL', {
    day: 'numeric', month: 'long', year: 'numeric'
  });
  const formattedTime = new Date(message.created_at).toLocaleTimeString('nl-NL', {
    hour: '2-digit', minute: '2-digit'
  });

  const senderInitial = (message.sender_name || message.sender_firstname || '?')[0].toUpperCase();

  const canViewMessageMeta = ['docent', 'locatie_admin', 'super_admin'].includes(
    message.viewer_role
  );

  return (
    <div className={`vm-container ${visible ? 'vm-visible' : ''}`}>
      <div className="vm-wrapper">

        <button type="button" onClick={() => window.history.back()} className="vm-back-btn">
          <i className="bi bi-arrow-left"></i>
          <span>Terug</span>
        </button>

        <div className="vm-card">
          <div className="vm-card-header">
            <h1 className="vm-subject">
              {message.subject || <span className="vm-no-subject">geen onderwerp</span>}
            </h1>
            {message.admin_view ? (
              <span className="vm-admin-badge"><i className="bi bi-shield-check" />Toezichtweergave</span>
            ) : !message.is_read && message.receiver_id && (
              <span className="vm-unread-badge">Nieuw</span>
            )}
          </div>

          <div className="vm-meta">
            <div className="vm-meta-row">
              <div className="vm-avatar">{senderInitial}</div>
              <div className="vm-meta-info">
                <div className="vm-meta-label">Van</div>
                <div className="vm-meta-value">
                  {message.sender_name || `${message.sender_firstname || ''} ${message.sender_lastname || ''}`.trim()}
                  {canViewMessageMeta && message.sender_email && (
                    <span className="vm-meta-sub">{message.sender_email}</span>
                  )}
                </div>
              </div>
            </div>

            {canViewMessageMeta && message.recipients && (
              <div className="vm-meta-row">
                <div className="vm-meta-icon">
                  <i className="bi bi-people"></i>
                </div>
                <div className="vm-meta-info">
                  <div className="vm-meta-label">Aan</div>
                  <div className="vm-recipients">
                    {(message.admin_view || message.viewer_is_sender) && Array.isArray(message.recipient_details)
                      ? message.recipient_details.map((recipient) => (
                          <span key={recipient.user_id} className="vm-recipient-detail">
                            <span>{recipient.name}</span>
                            <small className={recipient.is_read ? 'vm-recipient-read' : 'vm-recipient-unread'}>
                              {recipient.is_read ? 'Gelezen' : 'Ongelezen'}
                            </small>
                          </span>
                        ))
                      : message.recipients.split(',').map((recipient, index) => (
                          <span key={index} className="vm-recipient-chip">{recipient.trim()}</span>
                        ))}
                  </div>
                </div>
              </div>
            )}

            <div className="vm-meta-row">
              <div className="vm-meta-icon">
                <i className="bi bi-clock"></i>
              </div>
              <div className="vm-meta-info">
                <div className="vm-meta-label">Datum</div>
                <div className="vm-meta-value">
                  {formattedDate}
                  <span className="vm-meta-sub">{formattedTime}</span>
                </div>
              </div>
            </div>
          </div>

          <div className="vm-body-wrapper">
            <div className="vm-body">
              {message.body}
            </div>
          </div>

          {!message.admin_view && message.viewer_is_receiver && (message.id || message.message_id) && (
            <div className="vm-footer">
              <Link to={`/newmessage?reply=${message.id || message.message_id}`} className="vm-reply-btn">
                <i className="bi bi-reply me-2"></i>Beantwoorden
              </Link>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ViewMessage;
